import React from 'react'

const Loading = () => {
    return (
        <div className='py-3 my-2 w-100 text-center'>
            <div className="text-center">
                <div className="spinner-border text-secondary " role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    )
}

export default Loading;

// setTimeout(() => setLoading(false), 500);